import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import { Process, General } from '../redux/action/action';
import { Accordion } from 'react-bootstrap';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';

import TrashIcon from '../assets/images/basurero.png';
import { Tools } from '../utils/tools';
import FormFields from '../services/FormFields';
import ApiService from '../services/Api';
import { APIS } from '../services/Config';
import { Global } from '../services/Global';

let _fd = (localStorage.getItem('app_fd')) ? JSON.parse(Tools.decryptrData(localStorage.getItem('app_fd'))) : {};

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class WorkingDataPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_selected: null,
            fields: (_fd.aditional_data !== null) ? _fd.aditional_data : FormFields.aditional_data,
            next_active: true,
            rubrosEmpresa: [],

            business: [],

            selectionRange: {
                startDate: null,
                endDate: null,
                key: 'selection'
            },

            empresa: {
                id: '',
                idSubmission: '',
                nombreEmpresa: '',
                idRubroEmpresa: '',
                fechaDesde: '',
                fechaHasta: '',
                area: '',
                cargo: '',
                descripcionCargo: '',
                direccion: '',
                telefono: '',
                personaReferencia: '',
                cargoPersonaReferencia: '',
                orden: '',
                estado: ''
            }
        }
    }

    componentDidMount() {
        let _root = this;
        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {
            _root.state.empresa.idSubmission = _root.props.pro.idSubmission;
            _root.setState({
                program_selected: JSON.parse(Tools.decryptrData(localStorage.getItem('app_sp'))),
                empresa: _root.state.empresa,
                rubrosEmpresa: _root.props.glo.rubrosEmpresa
            }, () => {
                let _idSubmission = _root.props.pro.idSubmission;
                if (_root.props.glo.userfindsub !== null) {
                    _idSubmission = _root.props.glo.userfindsub.idSubmission;
                }
                let _business = _root.state.business;
                ApiService.getData(`${APIS.datoLaboralByIdSubmission}${_idSubmission}`)
                    .then(res => {
                        Tools.hidePreloader();
                        if (res.data.length > 0) {

                            res.data.forEach((element, index) => {

                                if (index === 0) {
                                    _root.state.empresa = res.data[0];
                                    _root.state.empresa.idSubmission = _root.props.pro.idSubmission;
                                    _root.state.empresa.id = (_root.props.glo.userfindsub !== null) ? 0 : res.data[0].id;
                                    _root.state.empresa.fechaDesde = Global.convertDateStartEnd(_root.state.empresa.fechaDesde);
                                    _root.state.empresa.fechaHasta = Global.convertDateStartEnd(_root.state.empresa.fechaHasta);

                                    _root.setState({
                                        empresa: _root.state.empresa
                                    })
                                } else {
                                    element.fechaDesde = Global.convertDateStartEnd(element.fechaDesde);
                                    element.fechaHasta = Global.convertDateStartEnd(element.fechaHasta);
                                    _business.push(element);

                                }
                            });
                            _root.setState({
                                business: _business
                            });
                        }

                        _root.props.general(_root.props.glo);
                    })
                    .catch(err => {
                        Tools.hidePreloader();
                        console.log(err);
                    });
            });
        }
    }

    onChangeDateRange = (ranges) => {
        // console.log(ranges);
    }

    onClickAddEmpresa = (e) => {
        e.preventDefault();
        let _root = this;
        let _business = _root.state.business;
        let data = {
            id: '',
            idSubmission: _root.props.pro.idSubmission,
            nombreEmpresa: '',
            idRubroEmpresa: '',
            fechaDesde: '',
            fechaHasta: '',
            area: '',
            cargo: '',
            descripcionCargo: '',
            direccion: '',
            telefono: '',
            personaReferencia: '',
            cargoPersonaReferencia: '',
            orden: '',
            estado: '',
            uuid: Global.createUUID()
        };

        if (_business.length < 4) {
            _business.push(data);
            _root.setState({
                business: _business
            });
        }
    }

    onClickRmEmpresa = (item) => (e) => {
        e.preventDefault();
        let _root = this;
        let _business = _root.state.business;
        if (!Global.isEmpty(item.id)) {
            Tools.showPreloader();
            ApiService.deleteData(`${APIS.datoLaboral}/${item.id}`)
                .then(res => {
                    Tools.hidePreloader();
                    let _businessn = _business.filter(function (obj) {
                        return obj.id !== item.id;
                    });
                    _root.setState({ business: _businessn });
                })
                .catch(err => {
                    Tools.hidePreloader();
                    console.log(err);
                });
        }
        else {
            Tools.showPreloader();

            setTimeout(() => {
                let _businessn = _business.filter(function (obj) {
                    return obj.uuid !== item.uuid;
                });
                Tools.hidePreloader();
                _root.setState({ business: _businessn });
            }, 2000);
        }
    }

    onChange = e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;

        _root.state.empresa[_target.name] = _target.value;

        _root.setState({
            empresa: _root.state.empresa
        });
    }
    onChangeAditional = (e, index) => {
        e.preventDefault();
        let _target = e.target;
        let _root = this;
        let _business = [..._root.state.business];
        _business[index][_target.name] = _target.value;
        _root.setState({
            business: _business
        });

    }

    onBlur = e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;

        if (_target.name === 'telefono') {
            if (_target.value !== '') {
                if ((_target.value).length < 9) {
                    _target.classList.add('require');
                    _target.parentNode.querySelector('.invalid-feedback').textContent = 'Teléfono mínimo 9 dígitos';
                    _target.parentNode.querySelector('.invalid-feedback').style.display = 'block';
                    _root.setState({
                        next_active: false
                    });
                }
                else {
                    _target.classList.remove('require');
                    _target.parentNode.querySelector('.invalid-feedback').textContent = '';
                    _target.parentNode.querySelector('.invalid-feedback').style.display = 'none';
                    _root.setState({
                        next_active: true
                    });
                }
            }
            else {
                _target.classList.remove('require');
            }
        }
        else {
            if (_target.name === 'fechaDesde' || _target.name === 'fechaHasta') {
                if (Global.validateDateStartEnd(_target.value)) {
                    if (_root.state.empresa['fechaDesde'] !== '' && _root.state.empresa['fechaHasta'] !== '') {
                        if (!Global.checkGreaterDates((`01-${_root.state.empresa['fechaDesde']}`).split('-').reverse().join('-'), (`01-${_root.state.empresa['fechaHasta']}`).split('-').reverse().join('-'))) {
                            Tools.showToaster('error', '', 'La Fecha desde no puede ser mayor o igual que Hasta...');
                            _root.state.empresa[_target.name] = '';
                            _root.setState({ empresa: _root.state.empresa });
                        }
                    }
                }
                else {
                    Tools.showToaster('error', '', 'Ingresa una fecha válida');
                    _root.state.empresa[_target.name] = '';
                    _root.setState({ empresa: _root.state.empresa });
                }
            }
        }

        if (_target.getAttribute('data-require')) {
            let _valid_msg = _target.parentNode.querySelector('.invalid-feedback');
            if (_target.value === '') {
                _target.classList.add('require');
                if (_target.getAttribute('data-requiremessage')) {
                    Global.addMsgError(_valid_msg, _target.getAttribute('data-requiremessage'));
                }
            }
            else {
                Global.addMsgError(_valid_msg, '');
                _target.classList.remove('require');
            }
        }
    }

    onKeyPressInputValidate = param => (event) => {
        let _target = event.target;

        switch (_target.name) {
            case '':
                break;
            default:
                Global.onKeyPressInputValidate(event, param);
                break;
        }
    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;

        _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/datos-laborales'));
        _root.props.process(_root.props.pro);
        _root.props.general(_root.props.glo);



        //Validation fisrt empresa


        let _empresarr = [];
        _root.state.empresa.idSubmission = _root.props.pro.idSubmission;
        if (_root.state.empresa.nombreEmpresa === '') { _empresarr.push(''); }
        if (_root.state.empresa.idRubroEmpresa === '') { _empresarr.push(''); }
        if (_root.state.empresa.idRubroEmpresa === 'Selecciona una opción') { _empresarr.push(''); }
        if (_root.state.empresa.fechaDesde === '') { _empresarr.push(''); }
        if (_root.state.empresa.fechaHasta === '') { _empresarr.push(''); }
        if (_root.state.empresa.fechaDesde === '-01') { _empresarr.push(''); }
        if (_root.state.empresa.fechaHasta === '-01') { _empresarr.push(''); }
        if (_root.state.empresa.area === '') { _empresarr.push(''); }
        if (_root.state.empresa.cargo === '') { _empresarr.push(''); }
        if (_root.state.empresa.descripcionCargo === '') { _empresarr.push(''); }
        // if(_root.state.empresa.direccion == '') { _empresarr.push('');}
        // if(_root.state.empresa.telefono == '') { _empresarr.push('');}
        // if(_root.state.empresa.personaReferencia == '') { _empresarr.push('');}
        // if(_root.state.empresa.cargoPersonaReferencia == '') { _empresarr.push('');}

        console.log('business', _root.state.business);

        //validate data from lista aditional accounts
        let isValidateAditionalAccount = true;
        _root.state.business.forEach(async (element, index) => {

            if (
                (element.nombreEmpresa === '') ||
                (element.fechaDesde === '' || element.fechaHasta === '') ||
                (element.idRubroEmpresa === '') ||
                (element.idRubroEmpresa === 'Selecciona una opción')
            ) {
                Tools.showToaster('warning', '', `Ingrese los campos obligatorios de la Empresa ${index + 2}.`);
                isValidateAditionalAccount = false;
            }
        });
        if (!isValidateAditionalAccount) return;
        //Guardando informacion adional
        Tools.showPreloader();
        _root.state.business.forEach(async (element, index) => {
            element.fechaDesde = (`20-${element.fechaDesde}`).split('-').reverse().join('-');
            element.fechaHasta = (`20-${element.fechaHasta}`).split('-').reverse().join('-');
            await ApiService.postData(`${APIS.datoLaboral}`, element);
        });
        Tools.hidePreloader();


        //#Validación de campos
        let isValidateForm = [];
        isValidateForm = [...Global.formValidationList(FormFields.other_working_information, _root.state.empresa)];
        if (isValidateForm.length > 0) return false;

        if (_root.state.empresa.nombreEmpresa === '') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else if (_root.state.empresa.idRubroEmpresa === '') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else if (_root.state.empresa.idRubroEmpresa === 'Selecciona una opción') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else if (_root.state.empresa.fechaDesde === '') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else if (_root.state.empresa.fechaHasta === '') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else if (_root.state.empresa.fechaDesde === '-01') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else if (_root.state.empresa.fechaHasta === '-01') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else if (_root.state.empresa.area === '') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else if (_root.state.empresa.cargo === '') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else if (_root.state.empresa.descripcionCargo === '') { Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...'); }
        else {
            Tools.showPreloader();
            _root.state.empresa.fechaDesde = (`20-${_root.state.empresa.fechaDesde}`).split('-').reverse().join('-');
            _root.state.empresa.fechaHasta = (`20-${_root.state.empresa.fechaHasta}`).split('-').reverse().join('-');

            
            ApiService.postData(`${APIS.datoLaboral}`, _root.state.empresa)
                .then(res => {
                    Tools.hidePreloader();
                    ApiService.postData(`${APIS.submission}`, _root.props.pro)
                        .then(res => {
                            _root.props.navigate('/carta-presentacion');
                        })
                        .catch(err => {
                            Tools.hidePreloader();
                            console.log(err);
                        });
                })
                .catch(err => {
                    Tools.hidePreloader();
                    Tools.showToaster('warning', '', 'Ingresa los campos obligatorios...');
                    console.log(err);
                });
        }

    }

    render() {

        const {
            next_active,
            program_selected,
            rubrosEmpresa,
            business,
            empresa
        } = this.state;

        const {
            navigate
        } = this.props;

        return (
            <>
                <div className="container">
                    <div className="row app-layout-main">
                        <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                            {(program_selected !== null) ? <DashboardMenuComponent navigate={navigate} step={'2'} form={program_selected.form} /> : <></>}
                        </div>
                        <div className="col-md-9 right-side-dashboard">
                            <TopProcessComponent porcent="40" />
                            <div className="row content-dashboard">
                                <div className="col-sm-12">
                                    <div className="row pt-3 pb-3">
                                        <div className="col-sm-12 col-md-6"><TopComponent direction="back" label="Paso Previo" path="/informacion-laboral" /></div>
                                        <div className="col-sm-12 col-md-6">
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-6">
                                            <h5><strong>Datos Laborales</strong></h5>
                                        </div>
                                        <div className="col-sm-12 col-md-6 text-right">
                                            <small><strong>Comparte con nosotros más detalles de tus experiencias laborales anteriores.</strong></small>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12">
                                            <Accordion>
                                                <Accordion.Item  >
                                                    <Accordion.Header>Empresa 1</Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className="row pt-2 pb-2">
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="nombreEmpresa" className="pb-2">Nombre de la Empresa <span className="text-danger">*</span></label>
                                                                    <input type="text" className="form-control" id="nombreEmpresa" name="nombreEmpresa" aria-describedby="nameHelp" data-require="1" data-requiremessage="Nombre de la empresa es obligatorio." onChange={this.onChange} onBlur={this.onBlur} defaultValue={empresa.nombreEmpresa} />
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="idRubroEmpresa" className="pb-2">Actividad de la Empresa <span className="text-danger">*</span></label>
                                                                    <select className="form-control" id="idRubroEmpresa" name="idRubroEmpresa" data-require="1" data-requiremessage="Actividad de la empresa es obligatorio." onChange={this.onChange} onBlur={this.onBlur} value={empresa.idRubroEmpresa}>
                                                                        <option selected value="">Selecciona una opción</option>
                                                                        {
                                                                            rubrosEmpresa.map((item, i) => (
                                                                                <option key={(i + 1) + 're'} value={item.id}>{item.nombre}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2 gri">
                                                                    <label htmlFor="fechaDesde" className="pb-2">Desde - Hasta<span className="text-danger">*</span></label>
                                                                    <div className="input-tg-inline">
                                                                        <InputMask maskChar="" id="fechaDesde" className="form-control" mask="99-9999" name="fechaDesde" data-require="1" data-requiremessage="Desde y Hasta es obligatorio." value={empresa.fechaDesde} onChange={this.onChange} onBlur={this.onBlur} autoComplete="off" placeholder="Mes y año, ejm: 04-2001" />
                                                                        <InputMask maskChar="" id="fechaHasta" className="form-control" mask="99-9999" name="fechaHasta" data-require="1" data-requiremessage="Desde y Hasta es obligatorio." value={empresa.fechaHasta} onChange={this.onChange} onBlur={this.onBlur} autoComplete="off" placeholder="Mes y año, ejm: 05-2002" />
                                                                        {/* <input type="date" className="form-control" id="fechaDesde" name="fechaDesde" onChange={this.onChange} defaultValue={empresa.fechaDesde} aria-describedby="nameHelp"/>
                                                                <input type="date" className="form-control" id="fechaHasta" name="fechaHasta" onChange={this.onChange} defaultValue={empresa.fechaHasta} aria-describedby="nameHelp"/> */}
                                                                        <div className="invalid-feedback"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="area" className="pb-2">Area <span className="text-danger">*</span></label>
                                                                    <input type="text" className="form-control" id="area" name="area" data-require="1" data-requiremessage="Area es obligatorio." onBlur={this.onBlur} onChange={this.onChange} defaultValue={empresa.area} aria-describedby="nameHelp" />
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="cargo" className="pb-2">Cargo <span className="text-danger">*</span></label>
                                                                    <input type="text" className="form-control" id="cargo" name="cargo" data-require="1" data-requiremessage="Cargo es obligatorio." onBlur={this.onBlur} onChange={this.onChange} defaultValue={empresa.cargo} aria-describedby="nameHelp" />
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="descripcionCargo" className="pb-2">Descripción del Cargo <span className="text-danger">*</span></label>
                                                                    <input type="text" maxLength={250} className="form-control" id="descripcionCargo" name="descripcionCargo" data-require="1" data-requiremessage="Descripción del cargo es obligatorio." onBlur={this.onBlur} onChange={this.onChange} defaultValue={empresa.descripcionCargo} aria-describedby="nameHelp" />
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="direccion" className="pb-2">Dirección</label>
                                                                    <input type="text" className="form-control" id="direccion" name="direccion" onChange={this.onChange} defaultValue={empresa.direccion} aria-describedby="nameHelp" />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="telefono" className="pb-2">Teléfono Fijo o Celular</label>
                                                                    <input type="text" maxLength="9" className="form-control" id="telefono" name="telefono" onChange={this.onChange} onBlur={this.onBlur} defaultValue={empresa.telefono} onKeyPress={this.onKeyPressInputValidate('only_number_positive')} aria-describedby="nameHelp" />
                                                                    <div className="invalid-feedback"></div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="personaReferencia" className="pb-2">Persona de Referencia</label>
                                                                    <input type="text" className="form-control" id="personaReferencia" name="personaReferencia" onChange={this.onChange} defaultValue={empresa.personaReferencia} aria-describedby="nameHelp" />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group pb-2">
                                                                    <label htmlFor="cargoPersonaReferencia" className="pb-2">Cargo de la Referencia</label>
                                                                    <input type="text" className="form-control" id="cargoPersonaReferencia" name="cargoPersonaReferencia" onChange={this.onChange} defaultValue={empresa.cargoPersonaReferencia} aria-describedby="nameHelp" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        </div>
                                    </div>

                                    {
                                        business.map((item, i) => (

                                            <div className="row pt-2 pb-2" key={(i + 1) + 'en'}>
                                                <div className="col-sm-12">
                                                    <Accordion>
                                                        <Accordion.Item eventKey={i}>
                                                            <Accordion.Header>Empresa {i + 2} <span className="del-btn" onClick={this.onClickRmEmpresa(item)}><img src={TrashIcon} alt='' /></span></Accordion.Header>
                                                            <Accordion.Body>
                                                                <div className="row pt-2 pb-2">
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2">
                                                                            <label htmlFor="nombreEmpresa" className="pb-2">Nombre de la Empresa <span className="text-danger">*</span></label>
                                                                            <input data-index={item.id} data-uuid={item.uuid} type="text" value={item.nombreEmpresa} onChange={(e) => this.onChangeAditional(e, i)} className="form-control" id="nombreEmpresa" name="nombreEmpresa" aria-describedby="nameHelp" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2">
                                                                            <label htmlFor="acti_empresa" className="pb-2">Actividad de la Empresa <span className="text-danger">*</span></label>
                                                                            <select className="form-control" id="acti_empresa" name="idRubroEmpresa" value={item.idRubroEmpresa} onChange={(e) => this.onChangeAditional(e, i)} >
                                                                                <option selected disable>Selecciona una opción</option>
                                                                                {
                                                                                    rubrosEmpresa.map((item, i) => (
                                                                                        <option key={(i + 1) + 're'} value={item.id}>{item.nombre}</option>
                                                                                    ))
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2 gri">
                                                                            <label htmlFor="fechaDesde" className="pb-2">Desde - Hasta<span className="text-danger">*</span></label>
                                                                            <div className="input-tg-inline">
                                                                                <InputMask maskChar="" id="fechaDesde" className="form-control" mask="99-9999" name="fechaDesde" data-require="1" data-requiremessage="Desde y Hasta es obligatorio." value={item.fechaDesde} onChange={(e) => this.onChangeAditional(e, i)} autoComplete="off" placeholder="Mes y año, ejm: 04-2001" />
                                                                                <InputMask maskChar="" id="fechaHasta" className="form-control" mask="99-9999" name="fechaHasta" data-require="1" data-requiremessage="Desde y Hasta es obligatorio." value={item.fechaHasta} onChange={(e) => this.onChangeAditional(e, i)} autoComplete="off" placeholder="Mes y año, ejm: 05-2002" />
                                                                                {/* <input type="date" className="form-control" id="fechaDesde" name="fechaDesde" onChange={this.onChange} defaultValue={empresa.fechaDesde} aria-describedby="nameHelp"/>
                                                                <input type="date" className="form-control" id="fechaHasta" name="fechaHasta" onChange={this.onChange} defaultValue={empresa.fechaHasta} aria-describedby="nameHelp"/> */}
                                                                                <div className="invalid-feedback"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2">
                                                                            <label htmlFor="area" className="pb-2">Area </label>
                                                                            <input type="text" maxLength={150} className="form-control" name="area" id="area" value={item.area} onChange={(e) => this.onChangeAditional(e, i)} aria-describedby="nameHelp" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2">
                                                                            <label htmlFor="cargo" className="pb-2">Cargo </label>
                                                                            <input type="text" maxLength={150} className="form-control" id="cargo" name="cargo" value={item.cargo} onChange={(e) => this.onChangeAditional(e, i)} aria-describedby="nameHelp" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2">
                                                                            <label htmlFor="desc_cargo" className="pb-2">Descripción del Cargo </label>
                                                                            <input type="text" maxLength={150} className="form-control" id="desc_cargo" name="descripcionCargo" value={item.descripcionCargo} onChange={(e) => this.onChangeAditional(e, i)} aria-describedby="nameHelp" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2">
                                                                            <label htmlFor="direccion" className="pb-2">Dirección </label>
                                                                            <input type="text" maxLength={150} className="form-control" id="direccion" name="direccion" value={item.direccion} onChange={(e) => this.onChangeAditional(e, i)} aria-describedby="nameHelp" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2">
                                                                            <label htmlFor="telefono" className="pb-2">Teléfono Fijo o Celular</label>
                                                                            <input type="text" maxLength="9" className="form-control" id="telefono" name="telefono" value={item.telefono} onChange={(e) => this.onChangeAditional(e, i)} onKeyPress={this.onKeyPressInputValidate('only_number_positive')} aria-describedby="nameHelp" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2">
                                                                            <label htmlFor="persona_ref" className="pb-2">Persona de Referencia </label>
                                                                            <input type="text" maxLength={150} className="form-control" name="personaReferencia" value={item.personaReferencia} onChange={(e) => this.onChangeAditional(e, i)} id="persona_ref" aria-describedby="nameHelp" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4">
                                                                        <div className="form-group pb-2">
                                                                            <label htmlFor="cargo_ref" className="pb-2">Cargo de la Referencia </label>
                                                                            <input type="text" className="form-control" name="cargoPersonaReferencia" value={item.cargoPersonaReferencia} onChange={(e) => this.onChangeAditional(e, i)} id="cargo_ref" aria-describedby="nameHelp" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    </Accordion>
                                                </div>
                                            </div>
                                        ))
                                    }

                                    {
                                        (business.length < 4)
                                            ?
                                            <div className="row pt-2 pb-2">
                                                <div className="col-sm-12">
                                                    <div className="accordion">
                                                        <div className="accordion-item">
                                                            <h2 className="accordion-header">
                                                                <button type="button" aria-expanded="false" className="accordion-button collapsed" onClick={this.onClickAddEmpresa}>Agregar Otras Empresas (Opcional)</button>
                                                            </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <></>
                                    }

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <small className="text-danger">*Obligatorio</small>
                                        </div>
                                        <div className="col-sm-12 col-md-4"></div>
                                        <div className="col-sm-12 col-md-4" style={{ textAlign: 'right' }}>
                                            <button className={(next_active) ? 'btn btn-primary btn-style-4' : 'btn btn-primary btn-style-4 disable'} onClick={this.onClickNext}>Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <DateRangePicker
                ranges={[selectionRange]}
                onChange={this.onChangeDateRange}
            /> */}
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkingDataPage);